const ColorCoded = require('../ui/color-coded');
const template = require('./success-rate.tpl').default;

module.exports = DomClass(template, function SuccessRate() {
	var _t = this;
	ColorCoded.call(this, String(this.value * 1));
	this['data-property'] = 'value';
});
